import { usePaywall } from '@/hooks/use-paywall';
import { PlanTier } from '@fluenceur/types';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { Lock } from 'iconoir-react';
import { useTranslation } from 'react-i18next';

/**
 * One line above a list holding masked prospects: what stays open first, what
 * the plan withholds next, and the way to the plans. Shown only when the list
 * does hold one, so a paying brand never reads it.
 */
export const PlanLocksBanner = ({
  title,
  text,
  ctaLabel,
}: {
  title?: string;
  text: string;
  ctaLabel?: string;
}) => {
  const { t } = useTranslation();
  const { openUpgradeModal } = usePaywall();

  return (
    <Flex
      role="note"
      align={{ base: 'flex-start', md: 'center' }}
      direction={{ base: 'column', md: 'row' }}
      gap={{ base: 2, md: 3 }}
      px="14px"
      py="10px"
      borderRadius="12px"
      borderWidth="1px"
      borderColor="hairline.field"
      bg="rowHoverBg"
      fontSize="13px"
    >
      <Flex gap="8px" align="flex-start" flex={1} minW={0}>
        <Flex color="inkMuted" pt="2px" flex="none" aria-hidden>
          <Lock width={14} height={14} />
        </Flex>
        <Box minW={0}>
          {title && (
            <Text color="ink" fontWeight="600" lineHeight="1.4">
              {title}
            </Text>
          )}
          <Text color="primary.600" lineHeight="1.5">
            {text}
          </Text>
        </Box>
      </Flex>
      <Button
        variant="plain"
        size="xs"
        h="auto"
        p={0}
        flex="none"
        fontSize="13px"
        fontWeight="600"
        color="ink"
        textDecoration="underline"
        textUnderlineOffset="2px"
        onClick={() => openUpgradeModal('generic', PlanTier.ESSENTIAL)}
      >
        {ctaLabel ?? t('planLocks.unlockCta')}
      </Button>
    </Flex>
  );
};
